import React from "react";

import { VStack, Box } from "../../primitive";
import { AnimatedStackItem } from "./components/AnimatedStackItem";
import { AnimatedStackProps } from "./types";

export const AnimatedStack = ({
  items,
  activeItemKeys,
}: AnimatedStackProps) => {
  return (
    <Box flexDirection="column" width="100%" flex={1}>
      <VStack
        flex={1}
        position="relative"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        {items.map((item) => {
          return (
            <AnimatedStackItem
              key={item.key}
              item={item}
              activeItemKeys={activeItemKeys}
            />
          );
        })}
      </VStack>
    </Box>
  );
};
